module.exports = function() {
  return new Worker(__webpack_public_path__ + "36209c3e83def357e102.worker.js");
};